import { useEffect, useState } from "react";
import axios from "axios";
import { FormGroup } from "reactstrap";
import "../../.csscode/PopUpModal.css";
import SucessModal from "../successModal/SuccessModal";
import Select from "react-select";
import CustomLoader from "../static/CustomLoader";
import { toast } from "sonner";

const Division = ({ selectedId, mode, onHide, setRefresh, empData }) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [id, setId] = useState("");
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [empcode, setEmpcode] = useState("");

  const [validation, setValidation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");

  useEffect(() => {
    fetchSelectedData();
  }, []);

  const fetchSelectedData = async () => {
    setLoading(true);
    try {
      if (selectedId !== "") {
        const response = await axios.get(`${apiUrl}division/${selectedId}`, {
          headers,
        });
        setId(response.data.id);
        setCode(response.data.code);
        setName(response.data.name);
        setEmpcode(response.data.empcode ? response.data.empcode : 0);
      }
      setLoading(false);
    } catch (error) {
      toast.error("Error fetching selected data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
    setRefresh(true);
  };

  function clearFields() {
    setName("");
    setValidation("");
  }

  const handlesubmit = async () => {
    setLoading(true);
    if (name === null || name === "") {
      toast.error("Please Enter Valid Name..!");
      setLoading(false);
      return;
    } else {
      if (mode === "A") {
        const work = {
          id: id,
          code: code,
          name: name,
          empcode: empcode,
        };
        const response = await axios.post(apiUrl + "division", work, {
          headers,
        });
        if (response.data.cd === 1) {
          setSucessMessage(response.data.description);
          setTitle("⚠️ Failed");
          setShowSucessModal(true);
          setLoading(false);
        } else {
          setSucessMessage(response.data.description);
          setTitle("✔️ Success");
          setShowSucessModal(true);
          setLoading(false);
        }
      } else {
        const work = {
          id: id,
          code: code,
          name: name,
          empcode: empcode,
        };
        const response = await axios.put(apiUrl + "division", work, {
          headers,
        });
        if (response.data.cd === 1) {
          setSucessMessage(response.data.description);
          setTitle("⚠️ Failed");
          setShowSucessModal(true);
          setLoading(false);
        } else {
          setSucessMessage(response.data.description);
          setTitle("✔️ Success");
          setShowSucessModal(true);
          setLoading(false);
        }
      }
    }
  };

  const handleEmpChange = (selectedOption) =>
    setEmpcode(selectedOption ? selectedOption.value : "");

  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      fontWeight: "normal",
      color: "#999",
    }),
    control: (provided) => ({
      ...provided,
      fontWeight: "normal",
      minHeight: "calc(1.5em + .75rem + 2px)",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  if (mode === "A") {
    /*Handle Update */
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />
        <div className="popupmodal-maindiv">
          <b>
            <label>Name</label>{" "}
          </b>
          <input
            required
            placeholder="Enter Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="form-control mb-2"
          ></input>
          {name.length === 0 && validation && (
            <span className="text-danger">Enter the Name</span>
          )}

          <FormGroup className="mb-3">
            <b>
              <label>Defalt Employee</label>{" "}
            </b>
            <Select
              name="Employee"
              isClearable
              required
              value={
                empcode
                  ? empData.find((option) => option.value === empcode)
                  : null
              }
              onChange={handleEmpChange}
              placeholder="Select Employee"
              options={empData}
              styles={customStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              classNamePrefix="select"
            />
            {empcode.length === 0 && validation && (
              <span className="text-danger">Select Employee</span>
            )}
          </FormGroup>

          <div className="bottombtn">
            <button
              className="btn btn-success"
              disabled={loading}
              onClick={handlesubmit}
            >
              Save
            </button>
            {loading && <CustomLoader />}
            <button className="btn btn-danger" onClick={clearFields}>
              Reset
            </button>
          </div>
        </div>
      </>
    );
  } else if (mode === "U") {
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />
        <div className="popupmodal-maindiv">
          <b>
            <label>Code</label>{" "}
          </b>
          <input
            required
            placeholder="Enter Code"
            value={code}
            onMouseDown={(e) => setValidation(true)}
            onChange={(e) => setCode(e.target.value)}
            className="form-control mb-2"
            disabled="disabled"
          ></input>
          {code.length === 0 && validation && (
            <span className="text-danger">Enter the Code</span>
          )}

          <b>
            <label>Name</label>{" "}
          </b>
          <input
            required
            placeholder="Enter Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="form-control mb-2"
          ></input>
          {name.length === 0 && validation && (
            <span className="text-danger">Enter the Name</span>
          )}

          <FormGroup className="mb-3">
            <b>
              <label>Defalt Employee</label>{" "}
            </b>
            <Select
              name="Employee"
              isClearable
              required
              value={
                empcode
                  ? empData.find((option) => option.value === empcode)
                  : null
              }
              onChange={handleEmpChange}
              placeholder="Select Employee"
              options={empData}
              styles={customStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              classNamePrefix="select"
            />
            {empcode.length === 0 && validation && (
              <span className="text-danger">Select Employee</span>
            )}
          </FormGroup>

          <div className="bottombtn">
            <button
              className="btn btn-success"
              disabled={loading}
              onClick={handlesubmit}
            >
              Save
            </button>
            {loading && <CustomLoader />}
            <button className="btn btn-danger" onClick={clearFields}>
              Reset
            </button>
          </div>
        </div>
      </>
    );
  }
};

export default Division;
